import { Container, Grid, Button, Box, Typography } from "@mui/material";

const Section = ({ children, ...props }) => {
  // TODO: allow just the `folder/uuid` to be provided? or the media id?
  return <Box {...props}>{children}</Box>;
};

export default Section;
